import * as React from 'react';

import { THEME_MODE_DARK, THEME_MODE_LIGHT } from 'theme/constants';
import { ThemeColorModes } from 'theme/colors';

import ThemeEditorColor from './ThemeEditorColor';

interface OnChangeParams {
  mode: string,
  key: string,
  type: string,
  hex: string,
}

type Props = {
  colorName: string,
  colorType: string,
  colorKey: string,
  currentThemeColors: ThemeColorModes,
  onChange: ({ mode, key, type, hex }: OnChangeParams) => void,
}

const ThemeEditorRow = ({ colorType, colorKey, colorName, currentThemeColors, onChange }: Props) => {
  const light = currentThemeColors[THEME_MODE_LIGHT][colorType][colorKey];
  const dark = currentThemeColors[THEME_MODE_DARK][colorType][colorKey];

  const handleChangeLight = (hex) => {
    onChange({ mode: THEME_MODE_LIGHT, key: colorKey, type: colorType, hex });
  };

  const handleChangeDark = (hex) => {
    onChange({ mode: THEME_MODE_DARK, key: colorKey, type: colorType, hex });
  };

  return (
    <li>
      <span>{colorName}</span>

      <ThemeEditorColor color={light} onChange={handleChangeLight} label={`edit light ${colorName} color`} />
      <ThemeEditorColor color={dark} onChange={handleChangeDark} label={`edit dark ${colorName} color`} />

      <span />
    </li>
  );
};

export default ThemeEditorRow;
